"use strict";
/*
 * Created on 11 10 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link SuppliedProduct}.
 * @author Radek Beran
 */


var SuppliedProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SuppliedProductConverter, _DataObjectConverter_);

  function SuppliedProductConverter() {
    _classCallCheck(this, SuppliedProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SuppliedProductConverter).apply(this, arguments));
  }

  return SuppliedProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SuppliedProductConverter = SuppliedProductConverter;